import { LogOut, Lock, ShieldCheck } from "lucide-react";
import { fmtDate } from "@/lib/format";
import { ContinueActions } from "@/components/company/ContinueActions";

export const TrialExpired = ({ company, onLogout, isAdmin = true }) => (
  <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6 relative overflow-hidden" data-testid="trial-expired-screen">
    <div className="absolute -top-32 -right-24 w-[28rem] h-[28rem] rounded-full bg-primary/25 blur-3xl" />
    <div className="relative w-full max-w-lg text-center space-y-6 animate-in-up">
      <img src="/k-gestionale.png" alt="K Gestionale" className="h-16 w-16 rounded-2xl mx-auto" />
      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mx-auto"><Lock className="w-6 h-6" /></div>
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">Prova gratuita scaduta</h1>
        <p className="text-slate-300 mt-3 leading-relaxed">
          I 14 giorni di prova di <strong className="text-white">{company?.ragione_sociale}</strong> sono terminati
          {company?.trial_ends_at ? ` il ${fmtDate(company.trial_ends_at)}` : ""}. Continua per tornare a usare K Gestionale.
        </p>
      </div>
      <div className="rounded-xl bg-white/5 border border-white/10 p-4 text-sm text-slate-300 flex items-center gap-3 text-left">
        <ShieldCheck className="w-5 h-5 text-emerald-400 shrink-0" />
        I tuoi dati (contatti, preventivi, fatture…) restano salvati e li ritroverai appena l'account viene riattivato.
      </div>
      <ContinueActions company={company} dark isAdmin={isAdmin} />
      <button onClick={onLogout} className="text-sm text-slate-400 hover:text-white inline-flex items-center gap-1.5" data-testid="trial-expired-logout">
        <LogOut className="w-4 h-4" /> Esci
      </button>
    </div>
  </div>
);

export default TrialExpired;
